import React from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/source-serif-4/400.css';
import '@fontsource/source-serif-4/600.css';
import { Application } from './components/SharedProgress.tsx';
import { log } from './logger.ts';
import './styles.css';

// Amber navigation is the selected default; other themes remain opt-in previews.
const design = new URLSearchParams(location.search).get('design') ?? 'nav';
if (design && ['paper', 'buttons', 'nav'].includes(design))
  document.documentElement.dataset.design = design;

const layout = new URLSearchParams(location.search).get('layout');
document.documentElement.dataset.layout =
  layout && ['footer', 'header', 'compact'].includes(layout) ? layout : 'header';

const frame = new URLSearchParams(location.search).get('frame');
if (frame && ['sage', 'sage-amber', 'sand', 'amber', 'original'].includes(frame))
  document.documentElement.dataset.frame = frame;

class ErrorBoundary extends React.Component<React.PropsWithChildren, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(error: Error) {
    log('error', 'app.render_failed', { name: error.name, message: error.message });
  }
  render() {
    return this.state.failed ? (
      <main>
        <h1>Something interrupted this page.</h1>
        <p>Reload to try again. Saved progress will be loaded when you reconnect.</p>
        <button onClick={() => location.reload()}>Reload</button>
      </main>
    ) : (
      this.props.children
    );
  }
}
createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <Application />
  </ErrorBoundary>,
);
